import { render, staticRenderFns } from "./SelectCampus.vue?vue&type=template&id=0968790f"
import script from "./SelectCampus.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCampus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0968790f')) {
      api.createRecord('0968790f', component.options)
    } else {
      api.reload('0968790f', component.options)
    }
    module.hot.accept("./SelectCampus.vue?vue&type=template&id=0968790f", function () {
      api.rerender('0968790f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/company/campus/components/SelectCampus.vue"
export default component.exports